import { ConsultationRecommendationOption } from '@/types/consultation'

export const DEFAULT_CONSULTATION_RECOMMENDATIONS: ConsultationRecommendationOption[] = [
  {
    code: 'refraction',
    label: 'Refraction',
    description: 'Detailed refraction assessment',
  },
  {
    code: 'visual_field_test',
    label: 'Visual Field Test',
    description: 'Perimetry / visual field analysis',
  },
  {
    code: 'dilate',
    label: 'Dilate',
    description: 'Patient needs pupillary dilation before further assessment or dispensing',
  },
  {
    code: 'surgery',
    label: 'Surgery',
    description: 'Surgical procedure recommended for this patient',
  },
]

/** Codes shipped in-app; custom catalog entries use other codes. */
export const BUILTIN_CONSULTATION_RECOMMENDATION_CODES: ReadonlySet<string> = new Set(
  DEFAULT_CONSULTATION_RECOMMENDATIONS.map((o) => o.code)
)
